import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import {
  Loading,
  UserFailure,
  UserRepository,
  VerificationCodeType,
} from "../domain";
import { ServiceLocater, Services } from "../service-locater";

type VerifyCode = {
  loading: Loading;
  failure?: UserFailure;
  code: string;
  token?: string;
};

const initialState: VerifyCode = {
  loading: "idle",
  code: "",
};

const verifyCodeSlice = createSlice({
  name: "verifyCode",
  initialState,
  reducers: {
    setCode(state, action) {
      state.failure = undefined;
      state.code = action.payload;
    },
    verifyCodeLoading(state) {
      state.failure = undefined;
      state.loading = "pending";
    },
    verifyCodeFailure(state, action) {
      state.failure = action.payload;
      state.loading = "failed";
    },
    verifyCodeSuccess(state, action) {
      state.token = action.payload;
      state.loading = "succeeded";
    },
  },
});

export const { setCode } = verifyCodeSlice.actions;
export default verifyCodeSlice.reducer;

const {
  verifyCodeLoading,
  verifyCodeFailure,
  verifyCodeSuccess,
} = verifyCodeSlice.actions;

export const verifyCode = (
  phone: string,
  type: VerificationCodeType
): AppThunk => async (dispatch, getState) => {
  dispatch(verifyCodeLoading());
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).verifyCode(phone, getState().verifyCode.code, type);
  res.fold(
    (l) => dispatch(verifyCodeFailure(l)),
    (r) => dispatch(verifyCodeSuccess(r))
  );
};

// LATER: for code resend
// export const sendCode = (
//   phone: string,
//   type: VerificationCodeType
// ): AppThunk => async (dispatch, getState) => {
//   dispatch(verifyCodeLoading());

//   let res;
//   if (type === "login") {
//     // TODO: add the method to repo
//     res = await ServiceLocater.get<UserRepository>(
//       Services.UserRepository
//     ).verifyCode(phone, getState().verifyCode.code, "login");
//   } else if (type === "register") {
//     // TODO: add the method to repo
//     res = await ServiceLocater.get<UserRepository>(
//       Services.UserRepository
//     ).verifyCode(phone, getState().verifyCode.code, "register");
//   } else {
//     // TODO: add the method to repo
//     res = await ServiceLocater.get<UserRepository>(
//       Services.UserRepository
//     ).verifyCode(phone, getState().verifyCode.code, "forgot-password");
//   }

//   res.fold(
//     (l) => dispatch(verifyCodeFailure(l)),
//     (r) => dispatch(verifyCodeSuccess(r))
//   );
// };
